import Icon from '../components/Icon.vue'

Icon.register({
  'thumbs-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-240zM40 256c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zM312 512c-20.2 0-29.5-39.3-33.9-57.8-5.2-21.7-10.6-44.1-25.4-58.9-32.5-32.5-49.5-74-89.1-113.1-2-1.9-3.6-5.8-3.6-8.5v0-213.8c0-6.5 5.2-11.9 11.8-12 15.8-0.3 36.7-9.1 52.7-16.2 31.8-14.1 71.3-31.7 119.6-31.7h2.8c42.8 0 93.4 0.4 113.8 29.7 8.4 12.1 10.4 27 6.1 44.6 16.3 17.1 25.1 48.9 16.4 74.8 17.5 23.4 19.1 56.1 9.3 79.5l0.1 0.1c11.9 11.9 19.5 31.3 19.4 49.2-0.2 30.4-26.2 58.1-59.6 58.1h-101.7c7.3 28.3 33.3 52.1 33.3 94.5 0 73.5-48 81.5-72 81.5z'
      }
    ]
  }
})
